import React from "react";
import "./renocss/RenovationSection.css";
import RenoImg from "../../../assets/images/bath2.jpeg";
import { FaHandPointRight } from "react-icons/fa6";
import TestimonialCarousel from "./testimonialCarousel/TestimonialCarousel";
import SpecialOffers from "../specialoffers/SpecialOffers";
import ContactWarrantySection from "../contactwaraanty/ContactWarrantySection";
import KitchenImg from "../../../assets/images/kitch-5.webp";
import bathroomImg from "../../../assets/images/Bathroom/bath20.webp";
import Homeimg from "../../../assets/images/Home/modern-luxury-bedroom-suite-bathroom-with-working-table.jpg";
import BasementImg from "../../../assets/images/Basement/luxury3d.webp";
// import ServiceAreas from "../services/ServiceAreas";

const RenovationSection = () => {
  return (
    <>
      <div className="container my-3 py-4">
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 p-4">
            <h2
              className="headingh2"
              data-sal="slide-right"
              data-sal-duration="1000"
              data-sal-delay="300"
            >
              Over Two Decades of <span>Excellence in Renovation</span>
            </h2>
            <p
              data-sal="slide-left"
              data-sal-duration="1000"
              data-sal-delay="300"
              className="goldendragonrenovations_panel_design_5"
              style={{ lineHeight: "1.8" }}
            >
              With nearly two decades of expertise, Velar Heights Renovation has
              been elevating homes through unmatched craftsmanship and
              commitment. Our skilled team of certified professionals is
              dedicated to delivering exceptional results, ensuring that every
              project meets the highest industry standards.
            </p>

            <div className="col-md-12 col-sm-12 col-xs-12 no-padding">
              <div
                className="listing_site"
                data-sal="slide-up"
                data-sal-duration="1000"
                data-sal-delay="300"
              >
                <ul>
                  <li
                    data-sal="slide-right"
                    data-sal-duration="2000"
                    data-sal-delay="400"
                  >
                    Cost-effective solutions tailored to your budget
                  </li>
                  <li
                    data-sal="slide-left"
                    data-sal-duration="2000"
                    data-sal-delay="400"
                  >
                    Regular updates to keep you informed every step of the way
                  </li>
                  <li
                    data-sal="slide-right"
                    data-sal-duration="2000"
                    data-sal-delay="400"
                  >
                    Experienced professionals delivering top-tier services
                  </li>
                  <li
                    data-sal="slide-left"
                    data-sal-duration="2000"
                    data-sal-delay="400"
                  >
                    Commitment to excellence in every aspect of our work
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-md-12 col-sm-12 col-xs-12 no-padding "  >
              <a href="/about">
                <button className="round_teo quote-btn" data-sal='slide-right' data-sal-duration="2000" data-sal-delay='800'>
                  About Us{" "}
                  <span className="blink-soft">
                    <FaHandPointRight size={30} />
                  </span>
                </button>
              </a>
            </div>
          </div>

          <div className="col-md-6 text-center" data-sal="slide-left" data-sal-duration="2000" data-sal-delay="300">
            <img 
              src={RenoImg}
              alt="Renovation Example"
              className="img-fluid rounded shadow hero-img"
            />
          </div>
        </div>
      </div>
      <div className="goldendragonrenovations_panel_design_6">
        <div className="container-fluid">
          <div
            className="col-md-12 col-sm-12 col-xs-12 "
            data-sal="slide-up"
            data-sal-duration="1000"
            data-sal-delay="400"
          >
            <h3>Our Expertise</h3>
          </div>

          <div className="services-row">
            <div
              className="service_box_1"
              data-sal="slide-right"
              data-sal-duration="1000"
              data-sal-delay="400"
            >
              <div className="image-container">
                <img className="service_pic_1" src={KitchenImg} alt="" />
              </div>
              <div className="text-container p-4">
                <h2 className="text-center">
                  <a href="/">
                    KITCHEN <span>RENOVATION</span>
                  </a>
                </h2>
                <p>
                  Transform your kitchen with contemporary designs and premium
                  finishes. Whether you're looking for a full renovation or just
                  some updates, we've got the perfect solution for you..
                </p>
              </div>
              <div className="t-c">
                <a href="/kitchen-renovations">
                  <button class="round_teo quote-btn">Learn More</button>
                </a>
              </div>
            </div>

            <div
              className="service_box_1"
              data-sal="slide-left"
              data-sal-duration="1000"
              data-sal-delay="400"
            >
              <div className="image-container ">
                <img className="service_pic_1" src={bathroomImg} alt="" />
              </div>
              <div className="text-container p-4">
                <h2 className="text-center">
                  <a href="/bathroom-renovation">
                    BATHROOM <span>RENOVATION</span>
                  </a>
                </h2>
                <p>
                  Transform your bathroom into a luxurious spa-like retreat.
                  From sleek showers to custom vanities, we create spaces that
                  combine beauty and functionality.
                </p>
              </div>
              <div className="t-c">
                <a href="/bathroom-renovation">
                  <button class="round_teo quote-btn">Learn More</button>
                </a>
              </div>
            </div>

            <div
              className="service_box_1"
              data-sal="slide-right"
              data-sal-duration="1000"
              data-sal-delay="400"
            >
              <div className="image-container">
                <img className="service_pic_1" src={Homeimg} alt="" />
              </div>
              <div className="text-container p-4">
                <h2 className="text-center">
                  <a href="/">
                    HOME <span>RENOVATIONS</span>
                  </a>
                </h2>
                <p>
                  Expand your home with our expert extension services. We design
                  and build seamless additions that integrate beautifully with
                  your existing space.
                </p>
              </div>
              <div className="t-c">
                <a href="/home-renovation">
                  <button class="round_teo quote-btn">Learn More</button>
                </a>
              </div>
            </div>

            <div
              className="service_box_1"
              data-sal="slide-left"
              data-sal-duration="1000"
              data-sal-delay="400"
            >
              <div className="image-container">
                <img className="service_pic_1" src={BasementImg} alt="" />
              </div>
              <div className="text-container p-4">
                <h2 className="text-center">
                  <a href="/">
                    BASEMENT <span>RENOVATIONS</span>
                  </a>
                </h2>
                <p>
                  Transform your basement into a vibrant, functional space
                  tailored to your lifestyle. From home theaters to gyms or
                  additional bedrooms .
                </p>
              </div>
              <div className="t-c">
                <a href="/basement-renovation">
                  <button class="round_teo quote-btn">Learn More</button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="goldendragonrenovations_panel_design_7 py-5 mb-5"
        style={{ fontFamily: "'Barlow Condensed', sans-serif" }}
      >
        <div className="container-fluid">
          <div className="row mb-4">
            <div className="col-12 text-center">
              <h3 data-sal ='slide-down' data-sal-duration="2000" data-sal-delay="300"
                className="fw-bold text-war text-center"
                style={{ textTransform: "capitalize" }}
              >
                WHY VELAR HEIGHTS RENOVATION?
              </h3>
            </div>
          </div>

          <div className="row g-4">
            {[
              {
                img: "assets/Images/why-1.png",
                title: "Premium Quality",
                span: "Service",
                desc: "Our high-grade renovation & redesign helps residences get a distinct appeal and look.",
              },
              {
                img: "assets/Images/why-2.png",
                title: "Customized",
                span: "Solution",
                desc: "Offering fully customized solutions to clients that want to implement their design ideas.",
              },
              {
                img: "assets/Images/why-3.png",
                title: "Satisfaction",
                span: "Guaranteed",
                desc: "We offer a 100% satisfaction guarantee to our clients for any home remodeling project.",
              },
              {
                img: "assets/Images/why-4.png",
                title: "On-time",
                span: "Completion",
                desc: "It is our proven track record that says about our commitment to project deadlines.",
              },
            ].map((item, index) => (
              <div className="col-12 col-sm-6 col-lg-3 "  data-sal="slide-right"
          data-sal-duration="2000" 
          data-sal-delay={`${index * 200}`} 
          data-sal-easing="ease-out-back" key={index}>
                <div className="text-center shadow-sm p-4 h-100 rounded">
                  <img
                    className="mb-3"
                    src={item.img}
                    alt={item.title}
                    style={{ height: 80 }}
                  />
                  <h2 className="fs-4 text-white text-center">
                    {item.title} <span className="text-war">{item.span}</span>
                  </h2>
                  <p className="text-white">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="mt-4">
        <TestimonialCarousel />

        <SpecialOffers />
        <ContactWarrantySection />
      </div>
    </>
  );
};

export default RenovationSection;
